import { render } from "./ScreenDimensionsDialog.vue?vue&type=template&id=99679dcc&scoped=true&ts=true"
import script from "./ScreenDimensionsDialog.vue?vue&type=script&lang=ts"
export * from "./ScreenDimensionsDialog.vue?vue&type=script&lang=ts"

import "./ScreenDimensionsDialog.vue?vue&type=style&index=0&id=99679dcc&lang=postcss&scoped=true"

import exportComponent from "/builds/wVusKqw4/1/kenniss/platform/educator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99679dcc"]])

export default __exports__